var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "literary_detail_paging"
  }, [_c('div', {
    staticClass: "paging_list_wrap"
  }, [_c('div', {
    staticClass: "paging_list_nav"
  }, [_c('a', {
    staticClass: "btn_paging_prev",
    style: _vm.prevBtnStyle,
    attrs: {
      "href": "#none"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.clickPreviousHandler.apply(null, arguments);
      }
    }
  }, [_c('span', {
    staticClass: "btn_text"
  }, [_vm._v("이전")])]), _c('a', {
    staticClass: "btn_paging_next",
    style: _vm.nextBtnStyle,
    attrs: {
      "href": "#none"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.clickNextHandler.apply(null, arguments);
      }
    }
  }, [_c('span', {
    staticClass: "btn_text"
  }, [_vm._v("다음")])])]), _c('div', {
    staticClass: "paging_list_util"
  }, [_c('a', {
    staticClass: "btn_paging_list",
    attrs: {
      "href": "#none"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.clickListHandler.apply(null, arguments);
      }
    }
  }, [_c('span', {
    staticClass: "btn_text"
  }, [_vm._v("목록으로")])]), _c('a', {
    staticClass: "btn_paging_share",
    attrs: {
      "href": "#none"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.clickShareHandler.apply(null, arguments);
      }
    }
  }, [_c('span', {
    staticClass: "btn_text"
  }, [_vm._v("공유하기")])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }